export const Modal = ({ open, handleClose, children }) => {
  return (
    <>
      {open && (
        <div
          className="fixed inset-0 z-[120] w-full h-full bg-white/50"
          onClick={() => handleClose()}
        >
          <div
          onClick={(e) => e.stopPropagation()}
            className={`fixed left-[50%] -translate-x-[50%] top-[50%] -translate-y-[50%] p-4 w-full max-w-2xl z-50 ${
                open ? "opacity-100" : "opacity-0"
            }`}
            style={{
              background: "linear-gradient(135deg, rgba(35,100,174,0.8), rgba(39,55,62,0.85))",
              border: "1px solid var(--brand-border)",
              color: "white",
              borderRadius: "12px"
            }}
        >
            {children}
          </div>
        </div>
      )}
    </>
  );
};
